// src/composables/usePermissions.js
import { computed } from 'vue'

export function usePermissions() {
  const permissions = computed(() =>
    JSON.parse(sessionStorage.getItem('permissions') || '[]')
  )

  function can(permission) {
    return permissions.value.includes(permission)
  }

  return { can }
}